const Util = {
    namespaced: true,
    state: {
        shopStatusFiltered: ["temp_close", "published", "draft", "inactive"],
    },
    actions: {
        setShopStatusFiltered({
            commit
        }, data) {
            commit('SET_SHOP_STATUS_FILTERED', data)
        },
    },
    mutations: {
        SET_SHOP_STATUS_FILTERED: (state, data) => {
            state.shopStatusFiltered = data
        },
    }

}
export default Util